import React, { useState, useEffect, useContext, useCallback } from 'react';
import 'react-tabs/style/react-tabs.css';

import ParticipantList from '../participantList';

import MessageBox from './MessageBox';
import {
  handleTwilioGlobalConv,
  globalChatOperations,
  listenUpdateNewMsgs,
  clearListenUpdateNewMsgs,
  globalConvCleanup,
  updateGlobalMsgFunc,
  getNewGlobalChatToken,
} from '../globalChat/globalChatFuncs';
import Client from '@twilio/conversations';

import RoomContext from '../../services/roomContext';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateMessages,
  clearMessages,
  clearGlobalNewMsgCount,
} from '../../redux/globalChatSlice';
import {
  updateMessages as updateBoxMsgs,
  clearMessages as clearBoxMsgs,
  clearBoxNewMsgCount,
} from '../../redux/boxChatSlice';

import {
  roomParticipantsListName,
  eventParticipantsListName,
} from '../../constants';

import { participantName } from '../../constants/liveStreamHelper';

import {
  updateNameToList,
  removeNameFromList,
  clearGlobalParticipantList,
} from '../../redux/participantListSlice';

import { getAndUpdateNewRoomChatToken } from '../roomChat/roomChatFuncs';

function ChatsContainer() {
  const { rooms, setRooms } = useContext(RoomContext);
  const [globalConversations, setGlobalConversations] = useState(null);
  const [showEmo, setShowEmo] = useState({ emoCode: 0 });

  const dispatch = useDispatch();
  const globalChat = useSelector((state) => state.globalChat);
  const streamInfo = useSelector((state) => state.streamInfo);
  const chatSelect = useSelector((state) => state.chatSelect);
  const movingBox = useSelector((state) => state.movingBox);
  // const roomParticipants = useSelector((state) => state.roomParticipantList);
  const [globalText, setGlobalText] = useState('');

  //All related to room chat

  const boxChat = useSelector((state) => state.boxChat);
  const [boxText, setBoxText] = useState('');
  const [boxConversations, setBoxConversations] = useState(null);

  //All related to global chat
  useEffect(() => {
    handleTwilioGlobalConv(
      streamInfo.userId,
      streamInfo.globalChatSid,
      streamInfo.participantName,
      setGlobalConversations
    );
  }, []);

  const addGlobalParticipants = (participants) => {
    participants?._c.forEach((each) => {
      dispatch(
        updateNameToList({
          identity: each.state.identity,
          listType: 'globalParticipants',
        })
      );
    });
  };

  const printMsgs = async (
    conversation,
    updateMessages,
    userId,
    updateFunc,
    from
  ) => {
    const msgs = await conversation?.getMessages(50);
    msgs?.items.forEach((eachMsg) => {
      updateFunc(eachMsg, '', dispatch, updateMessages, userId);
    });

    if (from === 'global') {
      addGlobalParticipants(conversation?.participants);
    }
  };

  useEffect(() => {
    if (rooms.activeGConversation) {
      printMsgs(
        rooms.activeGConversation,
        updateMessages,
        streamInfo.userId,
        updateGlobalMsgFunc,
        'global'
      );
      listenUpdateNewMsgs(
        rooms.activeGConversation,
        setShowEmo,
        dispatch,
        updateMessages,
        streamInfo.userId,
        updateNameToList,
        removeNameFromList
      );
      // // tokenAboutToExpire
      globalConversations?.on('tokenAboutToExpire', () => {
        getNewGlobalChatToken(
          streamInfo.userId,
          streamInfo.globalChatSid,
          streamInfo.participantName,
          globalConversations
        );
        // console.log('after token expired twilio global conv');
        // alert('global token expired');
      });
    }

    return () => {
      dispatch(clearMessages());
      dispatch(clearGlobalParticipantList());
      clearListenUpdateNewMsgs(rooms.activeGConversation);
      globalConversations?.off('tokenAboutToExpire', () => {
        getNewGlobalChatToken(
          streamInfo.userId,
          streamInfo.globalChatSid,
          streamInfo.participantName,
          globalConversations
        );
        // console.log('after token expired twilio global conv');
        // alert('global token expired');
      });
    };
  }, [rooms.activeGConversation]);

  useEffect(() => {
    if (globalConversations) {
      globalChatOperations(
        globalConversations,
        streamInfo.globalChatSid,
        setRooms,
        streamInfo.userId,
        streamInfo.participantName
      );
    }
    return () => {
      if (globalConversations) {
        globalConvCleanup(
          globalConversations,
          streamInfo.globalChatSid,
          setRooms
        );
      }
    };
  }, [globalConversations]);

  const globalOnClickSend = (e) => {
    rooms.activeGConversation.sendMessage(e);
  };

  const clearGlobalRoomNotification = useCallback(() => {
    chatSelect.allChatsHidden || dispatch(clearGlobalNewMsgCount());
  }, [chatSelect.allChatsHidden]);

  //All related to room chat

  const updateMsg = useCallback((x) => {
    // const seperatorIndex = x.author.indexOf('_') + 1;
    const { name, userId } = participantName(x.author);

    dispatch(
      updateBoxMsgs({
        newComment: x.body,
        name: name,
        identity: userId,
        newMsgCount: streamInfo.userId !== userId,
      })
    );
  }, []);

  const clearBoxRoomNotification = useCallback(() => {
    chatSelect.allChatsHidden || dispatch(clearBoxNewMsgCount());
  }, [chatSelect.allChatsHidden]);

  const connectToBoxConv = async (token) => {
    const boxConversations = await Client.create(token);
    setBoxConversations(boxConversations);
  };

  useEffect(() => {
    connectToBoxConv(boxChat.chatToken);
  }, []);

  useEffect(() => {
    if (boxConversations) {
      // tokenAboutToExpire
      boxConversations.on('tokenAboutToExpire', (p) => {
        // console.log(p, 'after token expired twilio local conv');
        // alert('local token expired');
        getAndUpdateNewRoomChatToken(
          streamInfo.userId,
          movingBox.currBoxChatSid,
          streamInfo.participantName,
          boxConversations
        );
      });

      boxConversations.on('connectionStateChanged', async (state) => {
        if (state === 'connected') {
        }
      });

      boxConversations.on('conversationJoined', (conversation) => {
        if (conversation.sid === boxChat.chatSID) {
          setRooms((prevState) => {
            if (prevState.activeBConversation?.sid !== conversation.sid) {
              return { ...prevState, activeBConversation: conversation };
            } else {
              return { ...prevState };
            }
          });
        }
      });
    }

    return () => {
      if (boxConversations) {
        boxConversations.removeAllListeners();
        boxConversations.shutdown();
        // tokenAboutToExpire
        boxConversations.off('tokenAboutToExpire', () => {
          // console.log('after token expired twilio local conv');
          // alert('local token expired');
          getAndUpdateNewRoomChatToken(
            streamInfo.userId,
            movingBox.currBoxChatSid,
            streamInfo.participantName,
            boxConversations
          );
        });
        boxConversations.off('connectionStateChanged', async (state) => {});

        boxConversations.off('conversationJoined', (conversation) => {
          if (conversation.sid === boxChat.chatSID) {
            setRooms((prevState) => {
              return { ...prevState, activeBConversation: null };
            });
          }
        });
      }
    };
  }, [boxConversations, boxChat.chatSID]);

  useEffect(() => {
    if (rooms.activeBConversation) {
      printMsgs(
        rooms.activeBConversation,
        updateBoxMsgs,
        streamInfo.userId,
        updateMsg
      );
      rooms.activeBConversation?.on('messageAdded', updateMsg);
    }
    return () => {
      rooms.activeBConversation?.off('messageAdded', updateMsg);
      dispatch(clearBoxMsgs());
    };
  }, [rooms, updateMsg, dispatch]);

  // rooms, updateMsg, dispatch

  const boxOnClickSend = (e) => {
    rooms.activeBConversation.sendMessage(e);
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {chatSelect.participantList.status ? (
        <ParticipantList
          listName={
            chatSelect.participantList.isGlobalParticipants
              ? eventParticipantsListName
              : roomParticipantsListName
          }
        />
      ) : chatSelect.globalChatSelect ? (
        <MessageBox
          text={globalText}
          setText={setGlobalText}
          onClickSend={globalOnClickSend}
          onClickEmoSend={globalOnClickSend}
          commentData={globalChat?.messages}
          isServiceActive={rooms.activeGConversation ? true : false}
          showEmo={showEmo}
          userId={streamInfo.userId}
          clearMsgNotification={clearGlobalRoomNotification}
          chatRange='(event chat)'
          participantName={streamInfo.participantName}
        />
      ) : (
        <MessageBox
          text={boxText}
          setText={setBoxText}
          onClickSend={boxOnClickSend}
          onClickEmoSend={globalOnClickSend}
          commentData={boxChat?.messages}
          isServiceActive={rooms.activeBConversation ? true : false}
          userId={streamInfo.userId}
          showEmo={showEmo}
          clearMsgNotification={clearBoxRoomNotification}
          chatRange='(table chat)'
          participantName={streamInfo.participantName}
        />
      )}
    </div>
  );
}

export default ChatsContainer;
